export default "__VITE_ASSET__Byy$tY$o__"